import { createStyles, makeStyles } from '@material-ui/core';
import { variables } from '../../styles';

export const useStyles = makeStyles(() =>
  createStyles({
    buttonGroup: {
      boxShadow: 'none',
      borderRadius: '50%',

      '& .MuiButton-outlined.Mui-disabled': {
        border: 'none',
        color: variables.black50,
        backgroundColor: variables.white,
        '& path': {
          stroke: variables.black50,
        },
      },
    },
    button: {
      padding: 7,
      minWidth: 24,
    },
    menuList: {
      textAlign: 'left',
    },
    menuItem: {
      height: 56,
      fontWeight: 600,
      fontSize: 16,
      color: variables.richBlack,
    },
    menuItemHierarchy: {
      height: 56,
      fontWeight: 600,
      fontSize: 16,
      color: variables.richBlack,

      '& svg': {
        marginLeft: '-13px',
      },
    },
    menuItemText: {
      marginInlineStart: 5,
    },
    menuTitle: {
      fontWeight: 700,
      fontSize: 12,
      paddingLeft: 16,
      paddingRight: 16,
    },
    popupPaper: {
      borderRadius: 15,
    },
    btn: {
      border: 'none',
      height: 56,
      color: variables.richBlack,
      fontSize: 16,
      fontWeight: 600,

      '&:hover': {
        color: variables.black50,
        backgroundColor: variables.white,

        '& path': {
          stroke: variables.black50,
        },
      },
    },
  }),
);
